export const OFFER_PAGE_PARAMS = {
  PROMO_ID: 'promo_id',
  IS_REWARD: 'is_reward',
  TYPE: 'type',
  TYPE_ID: 'type_id',
};

export const BOGO_TYPE = {
  Y: 2,
  X: 1,
};

export const PRODUCT_PAGINATION_KEY = 'product';
